var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6401 24.0964L13.2572 21.7135L11.96 23.0108L15.6401 26.6909L23.0002 19.3307L21.703 18.0334L15.6401 24.0964Z",
    fill: "#7B737B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4005 3.69H15.6404V2.76998C15.6389 2.28242 15.4446 1.81524 15.0999 1.47048C14.7551 1.12572 14.2879 0.931388 13.8004 0.929932H6.44017C5.9526 0.931388 5.48543 1.12572 5.14066 1.47048C4.7959 1.81524 4.60157 2.28242 4.60012 2.76998V3.69H1.84005C1.35248 3.69146 0.885307 3.88579 0.540546 4.23055C0.195785 4.57531 0.00145615 5.04249 0 5.53005V24.8506C0.00145615 25.3381 0.195785 25.8053 0.540546 26.1501C0.885307 26.4948 1.35248 26.6891 1.84005 26.6906H10.1203V24.8506H1.84005V5.53005H4.60012V8.29012H15.6404V5.53005H18.4005V15.6503H20.2405V5.53005C20.2391 5.04249 20.0447 4.57531 19.7 4.23055C19.3552 3.88579 18.888 3.69146 18.4005 3.69ZM13.8004 6.45007H6.44017V2.76998H13.8004V6.45007Z",
    fill: "#7B737B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.15d162a58c702d868e7ff1dc96ae72ff.svg";
export { ForwardRef as ReactComponent };